<template>
  <div class="page-tabs-block">
    <template v-if="tabItems">
      <div class="page-nav">
        <div class="features" v-if="featuresNav">
          <a
            href="javascript:void(0)"
            class="features-card"
            v-for="(tab, i) of compTabItems"
            :key="i"
            :class="{ active: tabInexes[i] }"
            @click="onClick(tab, i)"
            tabindex="0"
            role="button"
          >
            <div class="features-card-box">
              <div
                class="features-card-icon"
              >
                <img :src="require(`@/assets/images/${tabInexes[i] ? tab.iconActive : tab.icon}`)" :alt="tab.title"> 
              </div>
              <div class="features-card-text">{{ tab.title }}</div>
            </div>
          </a>
        </div>
        <div class="arrow-nav" v-if="arrowNav">
          <a
            href="javascript:void(0)"
            class="arrow-nav-card"
            v-for="(tab, i) of compTabItems"
            :key="i"
            :class="{ active: tabInexes[i] }"
            @click="onClick($event, i)"
            tabindex="0"
            role="button"
          >
            <div class="arrow-nav-card-text">{{ tab.title }}</div>
          </a>
        </div>
        <div
          class="nav-tabs-list"
          :class="tabListClass"
          v-if="!featuresNav && !arrowNav"
        >
          <a
            href="javascript:void(0)"
            class="nav-tabs-list-item"
            v-for="(tab, i) of compTabItems"
            :class="{ active: tabInexes[i] }"
            :key="i"
            @click="onClick($event, i)"
          >
           {{ tab.title }}
          </a>
        </div>
      </div>
      <div class="page-tabs">
        <template v-for="(tab, i) of compTabItems">
          <div
            v-if="tabInexes[i]"
            class="page-tabs-item"
            :class="{ active: tabInexes[i] }"
            :key="i"
          >
            <template v-if="tab.components">
              <template v-for="(component, index) of tab.components">
                <keep-alive :key="index">
                  <component        
                    :is="component.component"
                    v-bind="component.props"
                  ></component>
                </keep-alive>
              </template>
            </template>
            <slot v-else :name="tab.name"></slot>
          </div>
        </template>
      </div>  
    </template>    
  </div>
</template>
<script>
export default {
  name: "PageTabsBlock",
  props: {
    featuresNav: {
      type: Boolean,
      required: false,
      default: false,
    },
    arrowNav: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeTab: {
      type: Number,
      required: false,
      default: 0,
    },
    tabListClass: {
      type: String,
      required: false,
    },
    tabItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      compTabItems: [],
      tabInexes: []
    };
  },
  watch: {
    activeTab() {
      this.changeActive(this.activeTab);
    },
  },
  methods: {
    changeActive(index) {
      let arr = [];
      this.tabItems.forEach(() => {
        arr.push(false);
      })
      arr[index] = true;
      this.tabInexes = arr;
    },
    onClick(tab, index) {
      this.changeActive(index);
      this.$emit("on-click", index);
    }
  },
  created() {
    if (this.tabItems) {
      this.tabItems.forEach((el, i) => {
        this.compTabItems.push(el);
        if (i === this.activeTab) {
          this.tabInexes.push(true);
        } else {
          this.tabInexes.push(false);
        }
      });
    }
  },
};
</script>